import { useTranslation } from 'react-i18next';
import { getLandingContent } from '@/mocks/landingData';

export default function TasksSection() {
  const { i18n } = useTranslation();
  const { tasks } = getLandingContent(i18n.language);

  return (
    <section className="py-20 md:py-28 bg-gray-50">
      <div className="px-6 md:px-10 lg:px-16">
        <div className="text-center mb-4">
          <p className="text-red-600 text-sm font-medium tracking-widest uppercase mb-4">
            {tasks.eyebrow}
          </p>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 md:mb-6">
            {tasks.title}
          </h2>
          <p className="text-base text-gray-500 max-w-2xl mx-auto mb-14 md:mb-20 leading-relaxed">
            {tasks.subtitle}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {tasks.items.map((task, index) => (
            <div
              key={task.id}
              className={`bg-white rounded-lg p-7 md:p-8 border border-gray-100 shadow-soft hover:shadow-card transition-shadow duration-300 ${
                index === 3 ? 'lg:col-span-2' : ''
              }`}
            >
              <div className="flex items-start gap-4 mb-4">
                <div className="w-12 h-12 rounded-lg bg-red-50 flex items-center justify-center flex-shrink-0">
                  <i className={`${task.icon} text-red-600 text-xl w-6 h-6 flex items-center justify-center`}></i>
                </div>
                <h3 className="text-base md:text-lg font-semibold text-gray-900 leading-snug mt-2">
                  {task.title}
                </h3>
              </div>
              <p className="text-sm md:text-base text-gray-500 leading-relaxed">
                {task.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
